import { clsx } from 'helpers/utils/HTMLUtils';
import { languageValues } from 'helpers/utils/languageUtils';
import {
  ButtonThemes,
  CheckCircleIcon,
  Modal,
  ModalSizes,
  TimesCircleIcon,
} from 'plataforma-fundacao-componentes';

import { ModalProps } from 'plataforma-fundacao-componentes/dist/components/modal/Modal';
import './styles.scss';

interface MProps extends ModalProps {
  onConfirm: () => void;
  onlyConfirm?: boolean;
}

export const EventTestAlert = (props: MProps) => {
  return (
    <Modal
      className={clsx('root-modal-event-alert', {
        onlyConfirm: props.onlyConfirm,
      })}
      title={languageValues.modals.eventTestAlert.title}
      preventEscExit={props.preventEscExit}
      preventMaskExit={props.preventMaskExit}
      modalKey={props.modalKey}
      mobileOn={props.mobileOn}
      onClose={props.onClose}
      size={ModalSizes.Large}
      footer={
        props.onlyConfirm
          ? [
              {
                theme: ButtonThemes.Primary,
                leftIcon: <CheckCircleIcon />,
                children: 'Confirmar',
                onClick: () => {
                  props.onConfirm();
                  props.onClose!(props.modalKey);
                },
              },
            ]
          : [
              {
                theme: ButtonThemes.Secondary,
                leftIcon: <TimesCircleIcon />,
                children: 'Cancelar',
                onClick: () => props.onClose!(props.modalKey),
              },
              {
                theme: ButtonThemes.Primary,
                leftIcon: <CheckCircleIcon />,
                children: 'Confirmar',
                onClick: () => {
                  props.onConfirm();
                  props.onClose!(props.modalKey);
                },
              },
            ]
      }
    >
      <p className={'nunito'}>
        {languageValues.modals.eventTestAlert.description(props.onlyConfirm!)}
      </p>
    </Modal>
  );
};
